import React from 'react'
import { motion } from 'framer-motion'
import { skillsBar } from '../../utils/constants'
import {Badge, ImageBuffer, SubHeader} from '../'
import './skills.css'

const Skills = () => {

  return (
    <>
        <div id='skills' className='skills-wrapper'>
            <Badge title="What i do" />
            <SubHeader title="" description="As a software engineer, I deliver end-to-end solutions by managing both frontend and backend development, ensuring each application is robust, efficient, and intuitive for users." />
            
            <motion.div className="skills-container" whileInView={{y: [100, 50, 0], opacity: [0, 0, 1]}} transition={{ duration: 1.5 }}>
                <div className="skills-gradient-background"></div>
                <div className='skills-container-grid-box'>
                    {skillsBar.map((result, index) => {
                        return(
                            <div className="skills-main-box" key={index}>
                                <div className="skills-main-box-image">
                                    <ImageBuffer src={result.image} alt={result.title} />
                                </div>
                                <div className="skills-main-cover">
                                    <h3 className="skills-main-title">{result.title}</h3>
                                    <p className="skills-main-desc">{result.description}</p>
                                </div>
                            </div>
                        )  
                    })}
                </div>
            </motion.div>
        </div>
    </>
  )
}

export default Skills